import APIClient from "./APIClient";

export const GetAddress = async data => {
  const result = (await APIClient.post("https://se.optime-ai.com/search/single", data)).data
  // const result = (await APIClient.post("https://se.optime-ai.com/search/single_member", data )).data
  return result.slice(0, 4);
};

export const ReverseGeocode = async (data) => {
  return (await APIClient.post("https://se.optime-ai.com/search/reverse_geocode", data));
};

export const LoginAuth = async data => {
  return (await APIClient.post("https://se.optime-ai.com/auth/login", data));
};

export const RegisterUser = async data => {
  return (await APIClient.post("https://se.optime-ai.com/auth/signup", data));
};

export const CreateContract = async data => {
  return (await APIClient.post("https://se.optime-ai.com/plan/add", data));
};

export const EditContract = async data => {
  return (await APIClient.post("https://se.optime-ai.com/plan/update", data));
};

export const CheckLogin = async () => {
  return (await APIClient.get("https://se.optime-ai.com/auth/login_check"));
};

export const changeUserActivation = async data => {
  console.log('data', data)
  return (await APIClient.post("https://se.optime-ai.com/user/change_user_activation", data));
};

export const GetAllUsers = async (query) => {
  return (await APIClient.get("https://se.optime-ai.com/user/get_all", { params: query }));
};

export const GetAllUserRoles = async () => {
  return (await APIClient.get("https://se.optime-ai.com/user/get_all_roles"));
};

export const GetAllContracts = async (query) => {
  return (await APIClient.get("https://se.optime-ai.com/plan/get_all", { params: query }));
};

export const Logout = async () => {
  return (await APIClient.delete("https://se.optime-ai.com/auth/logout"));
};

export const UpdateSearchAddress = async (data) => {
  return (await APIClient.post("https://se.optime-ai.com/search/update", data));
};

export const AddNewSearchAddress = async (data) => {
  return (await APIClient.post("https://se.optime-ai.com/search/add", data));
};
